module.exports = __webpack_public_path__ + "img/instalogo.0ceb8f40.svg";